import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export const DEFAULT_WHATSAPP_COUNTRY = 'in';

export function normalizeWhatsAppValue(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  return digits ? `+${digits}` : '';
}

export function getCountryIso2FromPhone(phoneValue) {
  const parsed = parsePhoneNumberFromString(String(phoneValue || ''));
  return parsed?.country ? String(parsed.country).toLowerCase() : null;
}

export function validateWhatsAppNumberByCountry(phoneValue, countryIso2) {
  const normalized = normalizeWhatsAppValue(phoneValue);
  if (!normalized) return false;
  const parsed = parsePhoneNumberFromString(normalized);
  if (!parsed || !parsed.isValid()) return false;
  if (!countryIso2) return true;
  return String(parsed.country || '').toLowerCase() === String(countryIso2).toLowerCase();
}

export function getWhatsAppValidationMessage(countryLabel = 'selected country') {
  return `Enter a valid WhatsApp number for ${countryLabel}.`;
}
